import { Box, Grid, Typography } from "@mui/material";
import FormField from "components/FormField";
import SelectField from "components/SelectField";
import { memo } from "react";
import DatepickerField from "components/DatepickerField";
import SwitchField from "components/SwitchField";
import FormNumberField from "components/FormNumberField";

/* eslint-disable react/prop-types */

function Fields3({ formData }) {
  const { formField3, values, errors, touched } = formData;
  const {
    companyName,
    companyTaxId,
    taxAuthorities,
    numberSupplier,
    numberSupplierAuthority,
    period,

    firstTime,
    replaceNumber,
  } = formField3;
  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Grid spacing={3} container>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <FormField
            name={period.name}
            label={period.label}
            value={values.period}
            error={errors.period && touched.period}
            success={values.period?.toString().length > 0 && !errors.period}
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <SwitchField name={firstTime.name} label={firstTime.label} value={values.firstTime} />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <FormField
            name={replaceNumber.name}
            label={replaceNumber.label}
            value={values.replaceNumber}
            error={errors.replaceNumber && touched.replaceNumber}
            success={values.replaceNumber?.toString().length > 0 && !errors.replaceNumber}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={companyName.name}
            label={companyName.label}
            value={values.companyName}
            error={errors.companyName && touched.companyName}
            success={values.companyName?.toString().length > 0 && !errors.companyName}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={companyTaxId.name}
            label={companyTaxId.label}
            value={values.companyTaxId}
            error={errors.companyTaxId && touched.companyTaxId}
            success={values.companyTaxId?.toString().length > 0 && !errors.companyTaxId}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={taxAuthorities.name}
            label={taxAuthorities.label}
            value={values.taxAuthorities}
            error={errors.taxAuthorities && touched.taxAuthorities}
            success={values.taxAuthorities?.toString().length > 0 && !errors.taxAuthorities}
          />
        </Grid>
        {/* <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={numberSupplier.name}
            label={numberSupplier.label}
            value={values.numberSupplier}
            error={errors.numberSupplier && touched.numberSupplier}
            success={values.numberSupplier?.toString().length > 0 && !errors.numberSupplier}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={numberSupplierAuthority.name}
            label={numberSupplierAuthority.label}
            value={values.numberSupplierAuthority}
            error={errors.numberSupplierAuthority && touched.numberSupplierAuthority}
            success={
              values.numberSupplierAuthority?.toString().length > 0 &&
              !errors.numberSupplierAuthority
            }
          />
        </Grid> */}
      </Grid>
    </Box>
  );
}

export default memo(Fields3);
